export default {"src":"/_next/static/media/right-arrow-dark.8a21b7d4.svg","height":10,"width":11,"blurWidth":0,"blurHeight":0};